const AppLayout = (resolve) =>
  require(['@/components/layout/AppLayout'], resolve);
const _import = (path, subPath) =>
  require('@/components/page/meetingplan/' +
    path +
    (subPath ? `/${subPath}/index` : '/index'));

const routes = {
  path: '/meetingplan',
  component: AppLayout,
  meta: {
    title: 'meetingplan.application.title',
    hidden: false,
    name: 'meetingplan-application'
  },
  redirect: 'application',
  children: [
    {
      path: 'application',
      name: 'meetingplan-application',
      meta: {
        title: 'meetingplan.application',
        hidden: true,
      },
      component: _import('application')
    },
    {
      path: 'application/add/:year/:season',
      name: 'meetingplan-application-add',
      meta: {
        title: 'meetingplan.application.add',
        hidden: false,
      },
      component: _import('application','edit')
    },
    {
      path: 'application/copy/:id',
      name: 'meetingplan-application-copy',
      meta: {
        title: 'meetingplan.application.copy',
        hidden: false,
      },
      component: _import('application','edit')
    },
    {
      path: 'application/edit/:id',
      name: 'meetingplan-application-edit',
      meta: {
        title: 'meetingplan.application.edit',
        hidden: false,
      },
      component: _import('application','edit')
    },
    {
      path: 'application/change/:id',
      name: 'meetingplan-application-change',
      meta: {
        title: 'meetingplan.application.change',
        hidden: false,
      },
      component: _import('application','edit')
    },
    {
      path: 'application/view/:id',
      name: 'meetingplan-application-view',
      meta: {
        title: 'meetingplan.application.view',
        hidden: false,
      },
      component: _import('application','view')
    }
  ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/meetingplan.js